<script>
export default {
  name: 'DanSelect',
  props: {
    label: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    maxCount: {
      type: Number,
      default: 5,
    },
    onFocus: {
      type: Function,
      default: () => { },
    },
    onChange: {
      type: Function,
      default: () => { },
    },
    unit: {
      type: String,
      default: '星',
    },
  },
  data() {
    return {
      internalCount: this.count,
    };
  },
  watch: {
    count(newVal) {
      this.internalCount = newVal;
    },
    internalCount(newVal) {
      this.$emit('update:count', newVal);
    },
  },
  methods: {
    handleFocus() {
      this.onFocus();
    },
    handleChange() {
      this.onChange();
    },
    focus() {
      const input = this.$refs.input.$el.querySelector('input');
      input.focus();
      input.select();
    },
  },
};
</script>
<template>
  <div :class="`star-count-wrapper`">
    <span class="label-text">{{ label }}</span>
    <el-input ref="input" size="mini" v-model="internalCount" :style="{ width: '80px' }" @focus="handleFocus"
      @change="handleChange" clearable></el-input>
    <span class="star-text">{{ unit }}</span>
  </div>
</template>
<style scoped>
.star-count-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 2px;
}

.label-text {
  width: 50px;
}

.label-text,
.star-text {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  white-space: nowrap;
}

.el-rate {
  display: flex;
  align-items: center;
  margin-left: 0;
}

.el-input-number {
  min-width: 50px;
}
</style>
